/**
 *
 * Asynchronously loads the component for Login
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ResetPassword = lazyLoad(
  () => import('./index'),
  module => module.ResetPassword,
);
